/* Angular Component */
import { Component, Input, OnInit } from "@angular/core";
@Component({
  selector: "external-mam-panel",
  templateUrl: "./external-mam-panel.component.html",
  styleUrls: ["./external-mam-panel.component.scss"],
})
export class ExternalMAMPanelComponent {}
